module.exports = __webpack_public_path__ + "img/froot_logo.c72b6704.png";